import type { GetRequestsListItem } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { TABLE_LAYOUT_PRESETS } from "../../constants/columnWidths";
import { accountTagsCell } from "../../helpers/accountTagsCell";
import {
  inlineAssigneeCell,
  inlineBrandCell,
  inlineComplexityCell,
} from "../../helpers/cellRenderers";
import {
  accountCellWithSlotTooltip,
  designTypeCell,
  nameCell,
} from "../../helpers/commonCells";

// In Queue Section Configuration for Team Lead "Assigned to Me"
// Columns: Name, Account, Assignee, Level, Brand, Created by, Created date, Request/Design type, Tags
export const inQueueTableConfig: TableConfig<GetRequestsListItem> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.name,
    },
    {
      accessor: "account",
      cellRenderer: accountCellWithSlotTooltip,
      header: "Account",
      key: "account",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.account,
    },
    {
      accessor: "assignee",
      cellRenderer: inlineAssigneeCell,
      header: "Assignee",
      key: "assignee",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.assignee,
    },
    {
      accessor: "complexity",
      cellRenderer: inlineComplexityCell,
      header: "Level",
      key: "complexity",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.complexity,
    },
    {
      accessor: "brand",
      cellRenderer: inlineBrandCell,
      header: "Brand",
      key: "brand",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.brand,
    },
    {
      accessor: "designType",
      cellRenderer: designTypeCell,
      header: "Design Type",
      key: "designType",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.requestType,
    },
    {
      accessor: "account",
      cellRenderer: accountTagsCell,
      header: "Tags",
      key: "accountTags",
      sortable: false,
      width: 150,
    },
  ],
  defaultSort: {
    column: "name",
    direction: "asc",
  },
  getRowClassName: whitelabelRowClassName,
  id: "in-queue-section",
};
